module.exports = __webpack_public_path__ + "img/Activity.6fad31d6.png";